import api from "./axios";

export const listEmployeeTasks = (params = {}) => api.get("/employee-tasks", { params });
export const employeeTaskStats = (params = {}) => api.get("/employee-tasks/stats", { params });
export const getEmployeeTask = (id) => api.get(`/employee-tasks/${id}`);
export const updateEmployeeTask = (id, payload) => api.patch(`/employee-tasks/${id}`, payload);
export const assignEmployeeTask = (id, employee_id, reviewer_id = undefined) => {
  // Caller can pass `null` to explicitly clear the reviewer, or omit it to
  // leave the reviewer untouched. Forwarding `undefined` would still ship
  // the key with the value, so build the payload only with what was set.
  const payload = { employee_id };
  if (reviewer_id !== undefined) payload.reviewer_id = reviewer_id;
  return api.patch(`/employee-tasks/${id}/assign`, payload);
};
export const setEmployeeTaskReviewer = (id, reviewer_id) =>
  api.patch(`/employee-tasks/${id}`, { reviewer_id });
export const unassignEmployeeTask = (id) => api.patch(`/employee-tasks/${id}/unassign`);
export const updateEmployeeTaskStatus = (id, payload) =>
  api.patch(`/employee-tasks/${id}/status`, payload);
export const verifyEmployeeTask = (id) => api.patch(`/employee-tasks/${id}/verify`);
export const deleteEmployeeTask = (id) => api.delete(`/employee-tasks/${id}`);

export const listAdminTaskNotes = (employeeTaskId, params = {}) =>
  api.get(`/employee-tasks/${employeeTaskId}/notes`, { params });
export const createAdminTaskNote = (employeeTaskId, payload) =>
  api.post(`/employee-tasks/${employeeTaskId}/notes`, payload);
export const deleteAdminTaskNote = (noteId) => api.delete(`/task-notes/${noteId}`);
